import {createTheme} from "@mantine/core";

// Colour scheme: light only, deliberately. FNP-1412.
//
// Mantine's default is 'auto', which follows the operating system, so a user
// with a dark OS was already being served a dark app -- by inheritance, not by
// decision, and against styling nobody has ever reviewed in dark. The single
// brand colour below is one flat navy across all ten shades, which gives Mantine
// nothing to darken with, and the app ships no dark-mode design.
//
// Dark mode is not a platform feature today: @flexinet/ui-components exports a
// FlexiColorSchemeButton, but no application on the platform mounts it. When one
// does, this becomes a real toggle -- drop forceColorScheme in App.tsx, give
// 'flexinet' a genuine ten-step ramp, and review the layouts in both schemes.
// Until then, forcing light is what makes the rendered result match the design.

export const theme = createTheme({
                                     fontFamily: 'Inter',
                                     breakpoints: {
                                         xs: '500',
                                         sm: '800',
                                         md: '1000',
                                         lg: '1200',
                                         xl: '1400',
                                     },
                                     fontSizes: {
                                         xs: '12',
                                         sm: '14',
                                         md: '16',
                                         lg: '20',
                                         xl: '22',
                                     },
                                     headings: {
                                         // properties for all headings
                                         fontWeight: '400',
                                         fontFamily: 'Inter',

                                         // properties for individual headings, all of them are optional
                                         sizes: {
                                             h1: {
                                                 fontWeight: '500',
                                                 fontSize: '32px',
                                                 lineHeight: '1.4',
                                             },
                                             h2: {
                                                 fontWeight: '500',
                                                 fontSize: '28px',
                                                 lineHeight: '1.5'
                                             },
                                             // ...up to h6
                                             h6: {fontWeight: '900'},
                                         },
                                     },
                                     colors: {
                                         'flexinet': [
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74',
                                             '#194a74'],
                                     },
                                     primaryColor: 'flexinet',
                                 })


